module.exports = new __parcel__URL__("xp_icon.8c2513eb.png").toString();